import React from 'react';

export interface PubNubContextValue {
  client: any;
}

export const PubNubContext = React.createContext<PubNubContextValue | null>(null);
